/**
 * A price range is a number array of length 2
 * where the first number is a minimum price
 * and the second number is a maximum price.
 *
 * This adds the mins and maxes of two or more
 * price ranges and returns a price range.
 *
 * It returns null if all price ranges are null.
 */
const addPriceRanges = (...price_ranges) => {
  if (price_ranges.every((price_range) => !price_range)) {
    return null;
  }
  return price_ranges.filter(Boolean).reduce(
    (a, b) => {
      const [a_min, a_max] = a;
      const [b_min, b_max] = b;
      return [a_min + b_min, a_max + b_max];
    },
    [0, 0],
  );
};

export default addPriceRanges;
